import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/brand/gyre-icon-lg-bg-green.png'
import _imports_1 from '../assets/footer-images/iconmonstr-linkedin-4.svg'
import _imports_2 from '../assets/footer-images/iconmonstr-youtube-9.svg'


const _hoisted_1 = {
  class: "jyre-footer",
  style: {"position":"relative"},
  "data-test": "jyre-footer"
}
const _hoisted_2 = { class: "container text-center text-big" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    class: "a-unstyled",
    href: "https://gyreteams.com",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "footer-about-jyre-link"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      style: {"width":"80px","margin-bottom":"5px"},
      alt: "Gyre logo"
    }),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" About Gyre ")
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    class: "a-unstyled",
    href: "https://gyreteams.com/terms-and-conditions",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "footer-website-terms-link"
  }, "Terms and Conditions"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    class: "a-unstyled",
    href: "https://gyreteams.com/terms-of-service",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "footer-terms-of-service-link"
  }, "Terms of Service"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    class: "a-unstyled",
    href: "https://gyreteams.com/privacy-policy",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "footer-privacy-policy-link"
  }, "Privacy Policy"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    class: "a-unstyled",
    href: "https://gyreteams.com/cookie-policy",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "footer-cookies-link"
  }, "Cookies"),
  /*#__PURE__*/_createTextVNode(" - "),
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    class: "a-unstyled",
    href: "https://gyreteams.com/contact",
    target: "_blank",
    rel: "noopener noreferrer",
    "data-test": "footer-contact-us-link"
  }, "Contact Us")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1)
const _hoisted_8 = { "data-test": "footer-copyright" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"15px"} }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "icon-container" }, [
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    href: "https://www.linkedin.com/company/gyreteams",
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "linkedin"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_1,
      style: {"width":"40px"},
      alt: "linkedin icon"
    })
  ]),
  /*#__PURE__*/_createElementVNode("a", {
    role: "link",
    href: "https://www.youtube.com/@gyreteams",
    target: "_blank",
    rel: "noopener noreferrer",
    "aria-label": "youtube"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_2,
      style: {"width":"40px"},
      alt: "youtube icon"
    })
  ])
], -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"45px"} }, null, -1)

import { ref, onMounted, computed, watch } from "vue";

import moment from "dayjs";
import uiConfig from "../ui-config";


export default /*#__PURE__*/_defineComponent({
  __name: 'jyre-footer',
  setup(__props) {

const { release } = uiConfig;
const year = moment().year();

const animals = ref({
  octopus: "hiding",
  eagle: "hiding",
  chipmunk: "hiding",
  bear: "hiding",
  wolf: "hiding",
  chameleon: "hiding",
  orangutan: "offscreen",
});

const started = ref(false);
const done = ref(false);
const foundAll = ref(false);

const next = computed(() => {
  return Object.keys(animals.value).find((a) => animals.value[a] === "hiding");
});

function start(): void {
  started.value = true;
  window.setTimeout(() => {
    if (animals.value.orangutan === "offscreen") {
      animals.value.orangutan = "hiding";
    }
  }, 50);
}

function find(animal: string): void {
  started.value = true;
  animals.value[animal] = animals.value[animal] === "hiding" ? "found" : "hiding";

  if (!next.value) {
    foundAll.value = true;
    window.setTimeout(() => {
      done.value = true;
    }, 1000);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _hoisted_6,
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, [
        _createTextVNode(" © " + _toDisplayString(_unref(year)) + " - The Developing Leaders Partnership, trading as Gyre. Company Reg No: 10357459 ", 1),
        _hoisted_9
      ]),
      _hoisted_10,
      _hoisted_11,
      _hoisted_12
    ])
  ]))
}
}

})